import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { Router, RouterLink } from '@angular/router';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
// import { environment } from '../../../../environments/environment';
import { BookingConfigService } from '../../../services/booking-config.service';

@Component({
  selector: 'app-handle-booking',
  imports: [TextInputDataComponent, RouterLink, TranslocoModule, CommonModule],
  templateUrl: './handle-booking.component.html',
  styleUrl: './handle-booking.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [HandleBookingService]
})
export class HandleBookingComponent {

  handleBookingGroup: any;
  // site: string = environment.site;
  site: string;

  constructor(
    private handleBookingService: HandleBookingService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private bookingConfigService: BookingConfigService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    handleBookingService.initForm(this.site);
    this.handleBookingGroup = handleBookingService.getForm().get('handleBookingGroup');
  }

  goToHandleBookingForm() {
    let email = this.handleBookingService.getForm().get('handleBookingGroup').controls['email'].value;
    let booking_number = this.handleBookingService.getForm().get('handleBookingGroup').controls['bookingNumber'].value;
    if (email && booking_number) {
      this.handleBookingService.getBookingDetails(email, booking_number).subscribe({
        next: ((bookingDetails) => {
          if (bookingDetails.orderStatus != "Cancelled") {
            this.router.navigate(['parkifly/booking-overview', { email, booking_number }]);
          } else {
            this._snackBar.open("Bokningen är inte giltig längre", 'Stäng', {
              duration: 3000
            });
          }
        }),
        error: () => {
          this._snackBar.open("Ingen bokning hittades, la du bokningen nyss och betalade med kort kan det ta några minuter", 'Stäng', {
            duration: 3000
          });
        }
      })

    }
  }
}
